<mat-form-field [formGroup]="form" class="w-100" *ngIf="!loading">
  <input
    *ngIf="!passwordMatchDirective"
    matInput
    placeholder="{{ placeholder }}"
    type="{{ type }}"
    required
    name="{{ name }}"
    [formControl]="control"
    [autocomplete]="autocomplete"
  />

  <input
    *ngIf="passwordMatchDirective"
    matInput
    placeholder="{{ placeholder }}"
    type="{{ type }}"
    name="{{ name }}"
    required
    [formControl]="control"
    appConfirmEqualValidator="password"
  />
  <mat-icon matSuffix class="material-icons" *ngIf="iconName !== ''">{{
    iconName
  }}</mat-icon>

  <mat-error kj-error [control]="control"></mat-error>
</mat-form-field>
